import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Button,
  Chip,
  LogoLoader,
  Modal,
  showToast,
} from "../../../../components";
import { useLoginUser } from "../../../../hooks/useLoginUser";
import { pullMonsterCandidateResume } from "../../../../redux/slices/internalDbES/internalDbESApi";
import { getMonsterResumeImport } from "../../../../redux/slices/bdmjobs/bdmjobsApi";
import {
  getMonsterApplicantsDataStart,
  updateCareerBuilderApplicantsDataStart,
  updateMonsterApplicantsDataStart,
} from "../../../../redux/slices/internalDbES/internalDbESlice";
import {
  getAllApplicantsDataStart,
  getCareerBuilderApplicantsDataStart,
  setStateLoading,
  revertStateLoading,
} from "../../../../redux/slices/internalDbES/internalDbESlice";
import { useDispatch, useSelector } from "react-redux";
import { dateFormator } from "../../../../utils";
import { formatWords2 } from "../../../../utils/stringUtils";
import ProfileMigrationModel from "../Modals/ProfileMigrationModel";
import { fixResumeIfEntities } from "../../../../utils/resumeFixer";
import { setcareerBuilderAccessidStart } from "../../../../redux/slices/internalDbES/internalDbESlice";
import { setMonsterAccessidStart } from "../../../../redux/slices/internalDbES/internalDbESlice";
import { ENDPOINTS } from "../../../../redux/apiConfig";
import axiosRequest from "../../../../redux/slices/universal/axiosService";

const actionMap = {
  1: getAllApplicantsDataStart,
  2: getCareerBuilderApplicantsDataStart,
  3: getMonsterApplicantsDataStart,
};

const getJobBoardsName = {
  1: "Internal DB",
  2: "Career Builder",
  3: "Monster",
};
function tokenizeKeywords(keywords = []) {
  return keywords.flatMap((kw) =>
    kw
      .replace(/[“”]/g, '"')
      .split(/\s+/) // split by space
      .map((w) => w.trim())
      .filter(Boolean)
  );
}

function countKeywordsInResume(htmlResume = "", keywords = []) {
  if (!htmlResume || !Array.isArray(keywords) || keywords.length === 0) {
    return [];
  }

  const excludeWords = new Set(["and", "or", "not"]);
  const plainText = htmlResume.replace(/<[^>]*>/g, " ").toLowerCase();
  const uniqueKeywords = [...new Set(
    keywords
      .filter((kw) => typeof kw === "string" && kw.trim())
      .map((kw) => kw.trim().toLowerCase())
  )];

  return uniqueKeywords.map((kw) => {
    if (excludeWords.has(kw)) {
      return { title: kw, value: 0 };
    }
    const escaped = kw.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const regex = new RegExp(`\\b${escaped}\\b`, "gi");
    const matches = plainText.match(regex);
    return {
      title: kw,
      value: matches ? matches.length : 0,
    };
  });
}

function highlightKeywordsInHtmlResume(htmlResume = "", keywords = []) {
  if (!htmlResume) { //|| !Array.isArray(keywords) || keywords.length === 0
    return htmlResume;
  }
  const isPlainText = !/<\/?(p|div|span|table|html|body)/i.test(htmlResume);

  if (isPlainText && !htmlResume.includes("<pre>")) {
    htmlResume = `<pre>${htmlResume}</pre>`;
  }

  // Exclude generic words
  const fixedResume = fixResumeIfEntities(htmlResume)
  const excluded = new Set(["and", "or", "not"]);
  const validKeywords = keywords
    .filter(
      (kw) => typeof kw === "string" && kw.trim() && !excluded.has(kw.toLowerCase())
    )
    .map((kw) => kw.trim()).sort((a, b) => b.length - a.length);

  if (validKeywords.length === 0) return fixedResume;

  // Escape regex special chars and build one combined regex
  // const escaped = validKeywords.map((kw) =>
  //   kw.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
  // );
  //const regex = new RegExp(`\\b(${escaped.join("|")})\\b`, "gi");
  const regex = new RegExp(
    `(${validKeywords
      .map(kw =>
        kw.endsWith("*")
          ? `\\b${kw.slice(0, -1).replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\w*`
          : `\\b${kw.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\b`
      )
      .join("|")})`,
    "gi"
  );


  // Replace matches with <mark>
  const highlighted = fixedResume.replace(regex, (match) => {
    return `<mark class="highlight">${match}</mark>`;
  });

  return highlighted;
}

const Resume = ({ isOpen, source, candidate, keywords, searchQuery, loading = false, onClose: drawerClose }) => {
  const resumeLink = candidate?.resumes?.at(-1)?.files?.at(-1)?.key ?? "";
  const isDisabled = !resumeLink;
  const { user } = useSelector((state) => state.auth);
  const orgName = user?.data?.organizationId?.name;
  const { loginUserUiid } = useLoginUser();
  const dispatch = useDispatch();
  const [getResume, setGetResume] = useState(false);
  const [viewData, setViewData] = useState("");
  const [hasFetched, setHasFetched] = useState(false);
  const [showOriginal, setShowOriginal] = useState(false); // false = highlighted (default)
  const [saveAccessId, setSaveAccessId] = useState(0);
  const [saveMonsterAccessId, setSaveMonsterAccessId] = useState(0);
  const [isMergeModel, setIsMergeModel] = useState(false);
  const [cbExistingResponse, setCbExistingResponse] = useState();
  // const [monsterExistingResponse, setMonsterExistingResponse] = useState();

  const { careerBuilder } = useSelector((state) => state.internalDbES);
  const { tableResponse, fullResponse, existingCandidates } = careerBuilder;

  const { monster } = useSelector((state) => state.internalDbES);
  const {
    tableResponse: mTableResponse,
    fullResponse: mFullResponse,
    existingCandidates: mExistingCandidates,
  } = monster;
  const { accessData } = useSelector((state) => state.internalDbES);
  //console.log(loading)
  // Get Resume Helper
  const downloadResumeForCandidate = async () => {
    dispatch(setStateLoading());

    switch (source) {
      case 2: {
        const candidateData = {
          accessId: saveAccessId,
          userId:  user?.data?.uiid,
          payload: {
            source: 2,
            resumeId: candidate?.resumeId,
            // resumeId: "RQS2C96154NXMT15JD0",
            addedBy: loginUserUiid,
            jobTitle: candidate?.jobTitle || candidate?.resumeTitle,
            skills: keywords,
          },
        };

        try {
          const response = await pullMonsterCandidateResume(candidateData);
          const newCandidate = response?.data?.data?.response;
          const cBExistingCandidates = response?.field?.existingCandidates || [];

          if (response.success) {
            if (
              response?.data?.data?.response?.message ===
              "Candidate Already Exists"
            ) {
              setIsMergeModel(true);
              setCbExistingResponse(response?.data?.data?.response);
            } else {
              const existing = candidate;
              dispatch(
                updateCareerBuilderApplicantsDataStart({
                  existing,
                  newCandidate,
                  tableResponse,
                  fullResponse,
                  existingCandidates,
                })
              );
              // dispatch(selectedAction({
              //   ...searchQuery, onSuccess: () => {
              //     showToast("Resume Pulled Successflly.")
              //     drawerClose();
              //   }
              // }));
            }
          } else {
            if (response?.error == "Candidate already exists with the resumeId") {
              const existing = candidate;
              dispatch(
                updateCareerBuilderApplicantsDataStart({
                  existing,
                  newCandidate: cBExistingCandidates[0] || {},
                  tableResponse,
                  fullResponse,
                  existingCandidates
                })
              );
              showToast("Resume pulled successfully", "success", 2000);
            } else {
              if (response?.error) {
                showToast(response?.error, "error", 2000);
              } else {
                showToast("Resume Pulling Unsuccessful.", "error", 2000);
              }
              drawerClose();
            }
            dispatch(revertStateLoading());
          }
        } catch (error) {
          showToast("Something went wrong.", "error");
          drawerClose();
          dispatch(revertStateLoading());
        }

        break;
      }

      case 3: {
        const candidateData = {
          accessId: saveMonsterAccessId,
          payload: {
            resumeId: candidate?.resumeId,
            resumeBoardId: 1,
            firstName: candidate?.firstName,
            middleName: "",
            lastName: candidate?.lastName,
            addedBy: loginUserUiid,
            jobTitle:
              candidate?.experienceJobTitle || candidate?.jobTitle || "N/A",
            workAuth:
              `${candidate?.workAuthCountry} ${candidate?.workAuthType}`.trim(),
            workHistory: [
              {
                companyName: candidate?.experienceCompany || "",
                jobDetails: {
                  title: candidate?.experienceJobTitle || "",
                },
              },
            ],
            militaryExp: {},
            educationDetails: [
              {
                degree: candidate?.highestEducation || "",
              },
            ],
            orgName: orgName,
          },
        };

        try {
          const response = await getMonsterResumeImport(candidateData);
          // const newCandidate = response?.data?.data?.response;
          // const { old, new: newResponse } = newCandidate;  
          const newCandidate = response?.data?.data?.response ?? {};
          const { old = null, new: newResponse = null } = newCandidate;
          const monsterExistingCandidates = response?.field?.existingCandidates || [];

          if (response.success) {
            if (old && newResponse) {
              setIsMergeModel(true);
              setCbExistingResponse(newCandidate);
            } else {
              const existing = candidate;
              dispatch(
                updateMonsterApplicantsDataStart({
                  existing,
                  newCandidate,
                  tableResponse: mTableResponse,
                  fullResponse: mFullResponse,
                  existingCandidates: mExistingCandidates,
                })
              );
              showToast("Resume Pulled Successfully", "success", 2000);
            }
          } else {
            if (response?.error == "Candidate already exists with the resumeId") {
              const existing = candidate;
              dispatch(
                updateMonsterApplicantsDataStart({
                  existing,
                  newCandidate: monsterExistingCandidates[0] || {},
                  tableResponse: mTableResponse,
                  fullResponse: mFullResponse,
                  existingCandidates: mExistingCandidates,
                })
              );
              showToast("Resume Pulled Successfully", "success", 2000);
            }
            else {
              if (response?.error) {
                showToast(response?.error, "error", 2000);
              } else {
                showToast("Resume Pulling Unsuccessful.", "error", 2000);
              }
              drawerClose();
            }
            dispatch(revertStateLoading());
          }
        } catch (error) {
          showToast("Something went wrong.", "error");
          drawerClose();
          dispatch(revertStateLoading());
        }

        break;
      }
      default:
        console.log("No matching source found.");
    }
    dispatch(revertStateLoading());
  };

  const checkAndGetIfResumeExists = () => {
    switch (source) {
      case 1: {
        if (candidate?.resumes?.length > 0) {
          const resumesLength = candidate?.resumes?.length;
          const resumeDoc = candidate?.resumes[resumesLength - 1];
          const filesLength = resumeDoc?.files?.length;

          const latestResume = resumeDoc?.files[filesLength - 1]?.html;
          return latestResume || "Resume not available";
        } else { return candidate?.htmlResume || "Resume not available"; }
        break;
      }

      case 2: {
        if (candidate?.resumes?.length > 0) {
          const resumesLength = candidate?.resumes?.length;
          const resumeDoc = candidate?.resumes[resumesLength - 1];
          const filesLength = resumeDoc?.files?.length;

          const latestResume = resumeDoc?.files[filesLength - 1]?.html;
          return latestResume || "Resume not available";
        } else if(candidate?.uiid){
          if (candidate?.resumes?.length === 0) {
            return  "Resume not available";
          }
        }

        break;
      }
      case 3: {
        if (candidate?.resumes?.length > 0) {
          const resumesLength = candidate?.resumes?.length;
          const resumeDoc = candidate?.resumes[resumesLength - 1];
          const filesLength = resumeDoc?.files?.length;
          const latestResume = resumeDoc?.files[filesLength - 1]?.html;
          return latestResume || "Resume not available";
        }else if(candidate?.uiid){
          if (candidate?.resumes?.length === 0) {
          return  "Resume not available";
          }
        }


        break;
      }
    }
  };
  //console.log(candidate)
  const resumeDetails = countKeywordsInResume(
    showOriginal ? viewData : checkAndGetIfResumeExists(),
    keywords
  );
  const highlighted = highlightKeywordsInHtmlResume(
    showOriginal ? viewData : checkAndGetIfResumeExists(),
    keywords
  );

  useEffect(() => {
    dispatch(setStateLoading());
    const exists = checkAndGetIfResumeExists();
    setGetResume((prev) => (prev !== exists ? exists : prev));

    dispatch(revertStateLoading());
  }, [candidate]);

  useEffect(() => {
    if (isOpen) {
      const fetchIntegrationAccess = async () => {
        try {
          const params = {
            coll: "IntegrationAccess",
            fil: {
              userId: {
                type: "FIND_INTIGRATION_ACCESS",
                value: loginUserUiid,
                category: 3,
                categoryType: 2,
                status: 1
              },
            },
            useAggregate: true,
          };

          // const response = await getAllIntegrationAccess(params);

          const accessId = accessData?.careerBuilder?.[0]?.uiid
            ? accessData?.careerBuilder?.[0]?.uiid
            : dispatch(setcareerBuilderAccessidStart(params));
          const status =
            accessData?.careerBuilder?.[0]?.integrationData?.status ?? null;
          setSaveAccessId(accessId);
          if (typeof status !== "undefined") {
            if (status === 1) {
            } else {
              showToast(
                "Career Builder integration access not found. Please contact the administrator",
                "error"
              );
            }
          } else {
            showToast(
              "Career Builder integration status not found. Please contact the administrator",
              "error"
            );
          }
        } catch (err) {
          console.error("Error fetching integration access:", err);
        } finally {
        }
      };

      const fetchMonsterIntegrationAccess = async () => {
        try {
          const params = {
            coll: "IntegrationAccess",
            fil: {
              userId: {
                type: "FIND_INTIGRATION_ACCESS",
                value: loginUserUiid,
                category: 3,
                categoryType: 1,
                status: 1
              },
            },
            useAggregate: true,
          };

          // const response = await getAllIntegrationAccess(params);

          const status =
            accessData?.monster?.[0]?.integrationData?.status ?? null;
          const accessId = accessData?.monster?.[0]?.uiid
            ? accessData?.monster?.[0]?.uiid
            : dispatch(setMonsterAccessidStart(params));
          setSaveMonsterAccessId(accessId);
          if (typeof status !== "undefined") {
            if (status === 1) {
            } else {
              showToast(
                "Monster integration access not found. Please contact the administrator",
                "error"
              );
            }
          } else {
            showToast(
              "Monster integration status not found. Please contact the administrator",
              "error"
            );
          }
        } catch (err) {
          console.error("Error fetching integration access:", err);
        } finally {
        }
      };
      if (source == 2) {
        fetchIntegrationAccess();
      } else if (source == 3 || source == "Monster") {
        fetchMonsterIntegrationAccess();
      }
    }
  }, []);

  // console.log(candidate)

  // const resumeDetails = [
  //   {
  //     title: "Professional Engineering",
  //     value: 0,
  //   },
  //   {
  //     title: "Professional Engineer",
  //     value: 2,
  //   },
  //   {
  //     title: "Complex Category 2",
  //     value: 0,
  //   },
  //   {
  //     title: "Transportation",
  //     value: 3,
  //   },
  //   {
  //     title: "Construction",
  //     value: 18,
  //   },
  //   {
  //     title: "Inspection",
  //     value: 4,
  //   },
  //   {
  //     title: "Inspecting",
  //     value: 0,
  //   },
  //   {
  //     title: "Inspector",
  //     value: 0,
  //   },
  //   {
  //     title: "Bridge",
  //     value: 3,
  //   },
  //   {
  //     title: "Civil",
  //     value: 3,
  //   },
  //   {
  //     title: "CC2",
  //     value: 0,
  //   },
  //   {
  //     title: "P.E",
  //     value: 0,
  //   },
  //   {
  //     title: "P/E",
  //     value: 4,
  //   },
  //   {
  //     title: "PE",
  //     value: 1,
  //   },
  // ];

  function extractS3Key(url) {
    return url.replace(/^https?:\/\/[^/]+\//, "");
  }

  const viewResume = async () => {
    // If already fetched, just toggle
    if (hasFetched) {
      setShowOriginal((prev) => !prev);
      return;
    }

    try {
      const query = new URLSearchParams({
        key: extractS3Key(resumeLink),
        coll: "Candidate",
        html: true,
      }).toString();
      const url = `${ENDPOINTS.CANDIDATES.RESUME_URL}?${query}`;
      const response= await axiosRequest({method:"GET",url})
      if(response?.success){
         const data = `<pre>${response?.data?.data?.htmlContent}</pre>`;
      setViewData(data);
      setHasFetched(true);
      setShowOriginal(true); // switch to original view after fetch

      }else{
        showToast("error fetching clear Resume", "error")
        setHasFetched(true);
      }
    } catch (err) {
      console.error("Error fetching data:", err);
      setHasFetched(true);
    }
  };

  return !getResume ? (
    <div className="min-h-100 gap-4 flex  flex-col justify-center items-center">
      <p>
        By Clicking here, Credits will be used, and you will unlock the resume.
      </p>
      <Button
        title={"Get the Resume"}
        className="self-center"
        onClick={async () => {
          await downloadResumeForCandidate();
        }}
      />
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>

      <Modal
        isOpen={isMergeModel}
        onClose={() => {
          setIsMergeModel(false);
        }}
        title="Applicant Profile Migration"
        titleColor="primary"
        width="max-w-2xl"
      >
        <ProfileMigrationModel
          onCancel={() => {
            // drawerClose();
            setIsMergeModel(false);
          }}
          candidate={candidate}
          data={cbExistingResponse}
          source={source}
        />
      </Modal>
    </div>
  ) : (
    <div className="p-3">
      <div className="flex flex-wrap gap-2 mb-5">
        {Array.from({ length: resumeDetails.length }, (_, i) => (
          <Chip
            label={`${resumeDetails[i].title}-${resumeDetails[i].value}`}
            color={"info"}
            variant={"contained"}
            className="!bg-gray-50 !py-1 !border !border-info-100 text-info rounded-xl"
          />
        ))}
      </div>
      <div className="flex items-center my-3">
        <span>Migrated by</span>
        <div className="mx-2">
          <Chip
            label={
              formatWords2(candidate?.addedBy?.firstName) || candidate?.addedBy
            }
            color={"success"}
            icon={"person"}
            variant={"contained"}
            size="md"
            className="text-success !px-2"
          />
        </div>
        <span>from</span>
        <div className="mx-2">
          <Chip
            label={getJobBoardsName[candidate?.source]}
            color={"leave"}
            icon={"cloud_download"}
            variant={"contained"}
            size="md"
            className="text-leave !px-2"
          />
        </div>
        <span>on</span>
        <div className="mx-2">
          <Chip
            label={dateFormator(
              candidate?.addedOn || candidate?.modifiedOn,
              "datetime-ampm"
            )}
            icon={"calendar_month"}
            color="primary"
            variant={"contained"}
            size="md"
            className="text-primary !px-2"
          />
        </div>
      </div>
      {/* <p>
        Trouble viewing resume?{" "}
        <span className="text-blue-700 font-[700]">Click Here</span>
      </p> */}
      {/* <div className="flex flex-col flex-1 bg-gray-50 rounded p-4">
        <p className="mb-4">
          David J. Mosure, <mark>PE</mark>
          <br />
          Vice President, ms consultants, inc.
        </p>

        <p>
          Mr. Mosure, a professional engineer since 1983, brings 38 years’
          experience with public works infrastructure projects covering nearly
          every branch of
          <mark> construction</mark> administration;
          <mark> civil </mark>, environmental, mechanical and electrical
          engineering...
        </p>
      </div> */}

      <p>
        Trouble viewing resume?{" "}
          <span
            className={`font-[700] ${isDisabled
                ? "text-gray-400 cursor-not-allowed"
                : "text-blue-700 cursor-pointer"
              }`}
            onClick={!isDisabled ? viewResume : undefined}
          >
            {showOriginal ? "View Original Resume" : "View Clear Resume"}
          </span>
      </p>

      <div className="w-full">
        <div
          dangerouslySetInnerHTML={{
            __html: highlighted,
          }}
          className="[&_pre]:whitespace-pre-wrap [&_pre]:break-words [&_pre]:overflow-x-auto"
        />
      </div>

      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default Resume;
